import { IApplicationState } from '@bees-web/core/types'
import { getInteractiveGlobal } from '@bees-web/nfa-interactive-global'
import { AnyAction } from 'redux'
import { ThunkDispatch } from 'redux-thunk'

import { UseInteractive, InteractivesBuilder } from '@/core/types'
import { isBrowser } from '@/core/utils/environment'
import { getGlobalActions } from '@/utils/VL/context/sharedContext'

const fallback = (
  dispatch: ThunkDispatch<IApplicationState, Record<string, never>, AnyAction>,
  interactiveState: Record<string, any>
) => {
  if (!isBrowser) return {}

  try {
    return getInteractiveGlobal(dispatch, interactiveState)
  } catch (fallbackError) {
    console.error('Fallback getInteractiveGlobal failed:', fallbackError)
    return {}
  }
}

export const combineInteractives = (
  interactives: Record<string, UseInteractive> = {}
): InteractivesBuilder => {
  const interactiveKeys = Object.keys(interactives)

  if (interactiveKeys.length === 0) {
    return (dispatch, state) => fallback(dispatch, state.globals)
  }

  return (dispatch, state) => {
    try {
      if (!isBrowser) return {}

      const globalActions = getGlobalActions()
      const base = getInteractiveGlobal(dispatch, state.globals)

      for (let i = 0; i < interactiveKeys.length; i++) {
        // eslint-disable-next-line security/detect-object-injection
        const key = interactiveKeys[i]
        // eslint-disable-next-line security/detect-object-injection
        const fn = interactives[key]
        if (fn && typeof fn === 'function') {
          let result = {}
          try {
            result = fn(dispatch, state, globalActions)
          } catch (e) {
            // TODO: Replace this with a better error handling
            console.log(`Error calling '${key}' interactive:`, e)
          }
          if (result && typeof result === 'object') {
            Object.assign(base, result)
          }
        }
      }

      return base
    } catch (e) {
      console.error('Error combining interactives:', e)
      return fallback(dispatch, state.globals)
    }
  }
}
